/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 29.08.2016.
 */

import React, {Component, PropTypes} from 'react';
import ReactDOM from 'react-dom';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import moment from 'moment';

import ClassNames from 'classnames';
import ScrollArea from '../../../../ScrollArea';

import {
  StubFunc,
  getScroll,
  RDVR_STATES
} from '../../../../../utils';

import {FetchAssetById} from '../../../../../actions/asset/action-asset';

import {
  CancelRecoding
} from '../../../../../actions/npvr/action-npvr';


import {
  SetPlayer,
  SetSettingsState,
  OpenMessage
} from '../../../../../actions/common/actions-common';

import {ACTIONS} from '../../../../../containers/Player';

import DivLoader from '../../../../DivLoader';
import Translate from '../../../../Translate';

import _get from 'lodash/get';
import _find from 'lodash/find';
import _merge from 'lodash/merge';

class NpvrProfile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      picture: `/images/${Config.white_skin ? 'white' : 'black'}/event-no-image.png`,
      streamUrl: '',
      isPlayerShowed: false,
      streamCategory: null,
      momentStart: moment.unix(_get(this.props, 'record.start_time') || _get(this.props, 'record.schedule_time')),
      momentEnd: moment.unix((_get(this.props, 'record.start_time') || _get(this.props, 'record.schedule_time')) + _get(this.props, 'record.duration'))
    };
  }

  componentWillMount() {

    !this.props.channel && this.props.record.id && this.props.FetchAssetById(this.props.record.channel_id);
  }

  componentDidMount() {

    if (this.props.record.id) this._fetchRecordData(this.props.record);
  }

  componentWillReceiveProps(newProps) {

    let newState = {};

    if (this.props.record.id !== newProps.record.id && newProps.record.id) {
      this._stopPlayback();

      newState = _merge(newState, {
        picture: `/images/${Config.white_skin ? 'white' : 'black'}/event-no-image.png`,
        streamCategory: null,
        momentStart: moment.unix(_get(newProps, 'record.start_time') || _get(newProps, 'record.schedule_time')),
        momentEnd: moment.unix((_get(newProps, 'record.start_time') || _get(newProps, 'record.schedule_time')) + _get(newProps, 'record.duration'))
      });

      !newProps.channel && newProps.record.id && this.props.FetchAssetById(newProps.record.channel_id);

      this._fetchRecordData(newProps.record);
    }

    if (this.props.record.id && !newProps.record.id) {
      this._closeProfile();

    }

    if (newProps.playerIsDetached) {

      newState.isPlayerShowed = false;
    }

    this.setState(newState);
  }

  componentWillUnmount() {

    this._stopPlayback();
  }

  _fetchRecordData(record) {

    if (!record.epg_program) {
      return;
    }

    lh.models.record.methods
      .getPosterUrl(record.epg_program, {
        crop: {x: 460, y: 270},
        cache: false
      })
      .then((url) => {
        this.setState({picture: url});
      }, () => {
        this.setState({picture: `/images/${Config.white_skin ? 'white' : 'black'}/event-no-image.png`});
      });
  };

  _startPlayback(type) {
    if (this.props.user.user === 'guest') {

      this.props.SetSettingsState({
        isShown: true,
        tabId: 'login',
        meta: {
          fromPosition: getScroll()[1]
        }
      });

      return;
    }

    if (!_get(this.props, 'channel.is_purchased') && !_get(this.props, 'channel.is_available') && !_get(this.props, 'channel.is_free')) {

      this._showOffers();
      return;
    }

    if (_get(this.props.user, 'data.is_blocked')) {
      this.setState({isPlayerShowed: !this.props.playerIsDetached && true});

      this.props.SetPlayer({
        stream_url: null,
        action: ACTIONS.BLOCK,
        container: ReactDOM.findDOMNode(this),
        type: 'blocker',
      });

      return;
    }

    if (type === 'rdvr_hls') {

      lh.models.record.methods.getStreamUrl(this.props.record)
        .then((stream) => {

          this.setState({streamUrl: stream, isPlayerShowed: !this.props.playerIsDetached && true, streamCategory: 'rdvr_hls'});

          this.props.SetPlayer({
            stream_url: stream,
            container: ReactDOM.findDOMNode(this),
            action: ACTIONS.OPEN,
            //type: 'clpp',
            type: 'rmp',
            stream_type: type,
            monitoring: {
              assetTitle: _get(this.props, 'channel.title'),
              assetID: _get(this.props, 'channel.id'),
              programID: _get(this.props, 'record.epg_schedule_item_id'),
              duration: _get(this.props, 'record.duration'),
              type: 'npvr'
            },
            get_url_again_fn: lh.models.record.methods.getStreamUrl.bind(this, this.props.record)
          });
        }, this._processStreamError);
    }
  }

  _stopPlayback() {

    this.setState({isPlayerShowed: false});

    this.props.SetPlayer({
      stream_url: '',
      container: null,
      action: ACTIONS.CLOSE,
      monitoring: null
    });
  }

  _showOffers() {
    if (this.props.user.user === 'guest') {

      this.props.SetSettingsState({
        isShown: true,
        tabId: 'login',
        meta: {
          fromPosition: getScroll()[1]
        }
      });

      return;
    }

    this.props.OpenMessage({
      type: 'offers',
      asset_id: _get(this.props, 'channel.id'),
      actions: [
        {
          title: 'no_thanks',
          func: () => {
          }
        }
      ]
    });
  }

  _removeRecord() {

    if (this._isRdvrAvailable()) this.props.CancelRecoding(this.props.record.id);
  }

  _closeProfile() {

    this._stopPlayback();
    this.props.onClose();
  }

  _isNeedToPurchase(asset = this.props.channel) {

    return !asset.is_purchased && !asset.is_available && !asset.is_free;
  }

  _isRdvrAvailable() {

    return !!this.props.record.id;
  }

  _hasSubTitle() {

    return _get(this.props, 'record.title') !== _get(this.props, 'record.epg_program.title');
  }

  _showPlayButton() {

    return !this.state.isPlayerShowed && _get(this.props, 'record.state') === RDVR_STATES.FINISHED;
  }

  _onPlayerClick() {
    if (this.state.isPlayerShowed) return;

    if (_get(this.props, 'record.state') === RDVR_STATES.FINISHED) {

      this._startPlayback('rdvr_hls');
    }
  }

  _processStreamError = (reason) => {
    if (_get(reason, 'message') === 'subscriber blocked') {
      this.setState({isPlayerShowed: !this.props.playerIsDetached && true});

      this.props.SetPlayer({
        stream_url: null,
        action: ACTIONS.BLOCK,
        container: ReactDOM.findDOMNode(this),
        type: 'blocker',
      });
    } else if (_get(reason, 'message') === 'the requested content is not available in your geographical location') {
      this.setState({isPlayerShowed: !this.props.playerIsDetached && true});

      this.props.SetPlayer({
        stream_url: null,
        action: ACTIONS.GEO_BLOCK,
        container: ReactDOM.findDOMNode(this),
        type: 'geo-blocker',
      });
    } else {
      //TODO: SHOW ERROR CODE
      console.log('Failed:', reason);
    }
  };

  _renderRecordButton() {


    if (RDVR_STATES.FINISHED !== _get(this.props, 'record.state')) {

      return (<div className="mt-">
        <div className="color-grey pv-"><Translate content="profile.npvr.schedule_remove" /></div>
        <div>
          <a href="javascript:void(0)" className="hover" onClick={this._removeRecord.bind(this, _get(this.props, 'record'))}>
            <i className="ic ic-record-remove ic-24px"></i>
          </a>
        </div>
      </div>);
    } else {
      return (<div className="mt-">
        <div className="color-grey pv-"><Translate content="profile.npvr.record_remove" /></div>
        <div>
          <a href="javascript:void(0)" className="hover" onClick={this._removeRecord.bind(this, _get(this.props, 'record'))}>
            <i className="ic ic-record-trash ic-24px"></i>
          </a>
        </div>
      </div>);
    }
  }

  render() {
    if (!this.props.record.id) return <div className="profile event-inf-example bg-black radius"><DivLoader loading={true} /></div>;

    const playerDummyClasses = ClassNames({
      'hover pointer': this._showPlayButton(),
      'crow no-gutter player-dummy': true
    });

    return (
      <div className="profile event-inf-example bg-black radius">
        <DivLoader loading={this.props.inProgress} />
        <div className="profile-cols relative">
          <div className="channel-player-dummy relative">
            <div className={playerDummyClasses} onClick={this._onPlayerClick.bind(this)} style={{display: this.state.isPlayerShowed ? 'none' : 'block'}}>
              {!this.state.isPlayerShowed ? <img id="profile_poster" src={this.state.picture} alt="" /> : null}
              {!this._isNeedToPurchase() && this._showPlayButton() && <img src={`/images/${Config.white_skin ? 'white' : 'black'}/play.png`} style={{position: 'absolute', top: '50%', left: '50%', marginTop: '-30px', marginLeft: '-25px'}} />}
              { this._isNeedToPurchase() && this._showPlayButton() && <i className="ic ic-shopping-cart ic-32px" style={{position: 'absolute', top: '50%', left: '50%', marginTop: '-22px', marginLeft: '-18px'}}></i>}
            </div>
          </div>
          <div className="block-3 event-desc">
            <div>
              <div className="channel-title mt+">
                <b>{_get(this.props, 'channel.title', '')}</b>
              </div>
              <br />
              <div className="profile-bigtext m0">
                {this.state.momentStart.format(_get(Config, 'epg.epg_day_format', 'D MMMM'))}
              </div>
              <div className="profile-bigtext">
                {this.state.momentStart.format(_get(Config, 'epg.epg_event_time_format', 'HH:mm'))} - {this.state.momentEnd.format(_get(Config, 'epg.epg_event_time_format', 'HH:mm'))}
              </div>
              <div className="program-title">
                {_get(this.props.record, 'program.title', '')}
              </div>
              <ScrollArea
                speed={0.8}
                className="color-grey profile-text"
                horizontal={false}
                smoothScrolling={true}
                style={{height: '140px'}}>
                <div>
                  <div className="program-title mb-">
                    {this._hasSubTitle() && <span className="program-title color-white">{_get(this.props.record, 'epg_program.title', '')}</span>}
                  </div>
                  {_get(this.props.record, 'epg_program.description', '')}
                </div>
              </ScrollArea>
            </div>
          </div>
          <div className="block-1"></div>
          <div className="block-1 col-last">
            <div className="profile-r pr">
              <div className="profile-actions pr">
                {this._isRdvrAvailable() && this._renderRecordButton()}
              </div>
            </div>
          </div>
        </div>
        <a href="javascript:void(0)" className="mw-close ico ico-close slider-resume pointer" onClick={this._closeProfile.bind(this)}></a>
      </div>
    );
  }
}

NpvrProfile.propTypes = {
  npvrId: PropTypes.number.isRequired,
  record: PropTypes.object,
  user: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  SetPlayer: PropTypes.func.isRequired,
  SetSettingsState: PropTypes.func.isRequired,
  OpenMessage: PropTypes.func.isRequired,
  CancelRecoding: PropTypes.func.isRequired
};

NpvrProfile.defaultProps = {
  onClose: StubFunc.bind(this, 'onClose from Npvr Profile')
};

const mapStateToProps = function ({assets, npvr: {records}, auth: {user}, common: {player}}, ownProps) {
  let npvrForProfile = _find(records.collection, {id: ownProps.npvrId});
  let channel = _get(assets, _get(npvrForProfile, 'channel_id'));

  return {
    user,
    channel,
    record: npvrForProfile || {},
    playerIsDetached: !!player.isDetached
  }
};

const mapDispatchToProps = function (dispatch) {

  return bindActionCreators({SetPlayer, SetSettingsState, FetchAssetById, OpenMessage, CancelRecoding}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(NpvrProfile);



// WEBPACK FOOTER //
// ./src/components/ShowcaseCollection/Profile/Types/Npvr/npvr-profile.js